import styles from "@/styles/site-map.module.scss"
import Head from "next/head"
import { useEffect, useState } from "react";
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import { DownOutlined } from '@ant-design/icons';
import { Tree, Skeleton } from 'antd';
import type { TreeDataNode, TreeProps } from 'antd';
import homeApi from '@/service/modules/homeApi'

export default function SiteMap() {
  const [treeData, setTreeData] = useState<TreeDataNode[] | undefined>(undefined);

  function transformToTreeData(categories: any) {
    return categories.map((category: any) => ({
      title: category.name,
      key: `root-product_${category.url || category.categoryID.toString()}`,
      children: category.subCategories ? transformToTreeData(category.subCategories) : []
    }));
  }

  // 获取分类数据
  const getCategoryData = async () => {
    try {
      let res = await homeApi.getCategoryTree()
      if (res.data && res.data.tree) {
        const additionalTreeData = transformToTreeData(res.data.tree);

        const existingChildren = [
          { title: 'Clearance', key: '/clearance', children: [] },
          { title: 'Free Shipping', key: '/free-shipping', children: [] },
          { title: 'Top Reviewed', key: '/top-reviewed-1', children: [] },
          { title: 'Cheap Discount', key: '/cheap-discount-1', children: [] },
          { title: 'Featured Deals', key: '/featured-deals', children: [] },
          { title: 'Hottest Deals', key: '/hottest-deals', children: [] },
          { title: 'New Arrivals', key: '/new-arrivals', children: [] },
          { title: 'Special Promotions', key: '/special-promotions', children: [] }
        ];

        const productListData = [
          {
            title: 'Product Lists',
            key: 'product-lists',
            children: [...existingChildren, ...additionalTreeData]
          }
        ];

        setTreeData([
          {
            "title": "Home - CrazySales - Bargain & Discount Shopping Online",
            "key": "root_/",
            "children": []
          },
          {
            "title": "New Arrivals",
            "key": "root_/new-arrivals",
            "children": []
          },
          {
            "title": "Hottest Deals",
            "key": "root_/hottest-deals",
            "children": []
          },
          {
            "title": "Clearance Sale",
            "key": "root_/clearance",
            "children": []
          },
          {
            "title": "Register",
            "key": "root_/login",
            "children": []
          },
          {
            "title": "About Us",
            "key": "root_/article/AboutUs",
            "children": []
          },
          {
            "title": "Help centre",
            "key": "root_/article/faq",
            "children": []
          },
          {
            "title": "Contact Us",
            "key": "root_/contact-us",
            "children": []
          },
          {
            "title": "Top Search",
            "key": "root_/topsearch",
            "children": []
          },
          {
            "title": "AB Machines",
            "key": "root_/abdominal-machines/",
            "children": []
          },
          {
            "title": "Aerobic Step",
            "key": "root_/aerobic-steppers/",
            "children": []
          },
          {
            "title": "Automatic Pet Feeder",
            "key": "root_/pet-bowls/",
            "children": []
          },
          {
            "title": "Bar Stools",
            "key": "root_/bar-stools/",
            "children": []
          },
          {
            "title": "Bestway Air Mattress",
            "key": "root_/inflatable-air-beds/",
            "children": []
          },
          {
            "title": "Bestway Swimming Pools",
            "key": "root_/pools/",
            "children": []
          },
          {
            "title": "Cat Carrier",
            "key": "root_/pet-travel-carriers/",
            "children": []
          },
          {
            "title": "Cat Scratching Post",
            "key": "root_/scratching-posts/",
            "children": []
          },
          {
            "title": "Christmas Lights",
            "key": "root_/christmas-lights/",
            "children": []
          },
          {
            "title": "Dog Kennels",
            "key": "root_/dog-kennels/",
            "children": []
          },
          {
            "title": "Electric Water Pump",
            "key": "root_/pumps/",
            "children": []
          },
          {
            "title": "Exercise Bikes",
            "key": "root_/exercise-bikes/",
            "children": []
          },
          {
            "title": "Food Dehydrator",
            "key": "root_/dehydrators/",
            "children": []
          },
          {
            "title": "Gun Safes",
            "key": "root_/safes/",
            "children": []
          },
          {
            "title": "Kitchen Trolley",
            "key": "root_/kitchen-furniture/",
            "children": []
          },
          {
            "title": "Massage Table",
            "key": "root_/massage-therapy/",
            "children": []
          },
          {
            "title": "Memory Foam Mattress Topper",
            "key": "root_/toppers-underlays/",
            "children": []
          },
          {
            "title": "Office Chairs",
            "key": "root_/office-chairs/",
            "children": []
          },
          {
            "title": "Pest Repeller",
            "key": "root_/pest-control/",
            "children": []
          },
          {
            "title": "Portable Air Conditioners",
            "key": "root_/portable-air-conditioners-heaters/",
            "children": []
          },
          {
            "title": "Puppy Playpen",
            "key": "root_/pet-playpens/",
            "children": []
          },
          {
            "title": "Rubbish Bins",
            "key": "root_/bins/",
            "children": []
          },
          {
            "title": "Sewing Machines",
            "key": "root_/sewing-machines/",
            "children": []
          },
          {
            "title": "Shoe Rack",
            "key": "root_/shoe-organisers/",
            "children": []
          },
          {
            "title": "Steam Mop",
            "key": "root_/steam-mops-accessories/",
            "children": []
          },
          {
            "title": "Tool Boxes",
            "key": "root_/toolboxes/",
            "children": []
          },
          {
            "title": "Tv Wall Brackets",
            "key": "root_/wall-mounts-brackets/",
            "children": []
          },
          {
            "title": "Vacuum Cleaners",
            "key": "root_/handheld-bagless-robot-vacuum-cleaners/",
            "children": []
          },
          {
            "title": "Vacuum Sealer",
            "key": "root_/vacuum-sealer/",
            "children": []
          },
          {
            "title": "Wall Mounted Fan",
            "key": "root_/fans/",
            "children": []
          },
          {
            title: `Product Lists`,
            key: '',
            children: [
              {
                title: 'Clearance',
                key: 'root-product_/clearance',
                children: []
              },
              {
                title: 'Free Shipping',
                key: 'root-product_/free-shipping',
                children: []
              },
              {
                title: 'Top Reviewed',
                key: 'root-product_/top-reviewed-1',
                children: []
              },
              {
                title: 'Cheap Discount',
                key: 'root-product_/cheap-discount-1',
                children: []
              },
              {
                title: 'Featured Deals',
                key: 'root-product_/featured-deals',
                children: []
              },
              {
                title: 'Hottest Deals',
                key: 'root-product_/hottest-deals',
                children: []
              },
              {
                title: 'New Arrivals',
                key: 'root-product_/new-arrivals',
                children: []
              },
              {
                title: 'Special Promotions',
                key: 'root-product_/special-promotions',
                children: []
              },

              ...productListData
            ]
          }
        ])
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getCategoryData()
  }, [])

  // 点击树节点，触发跳转
  const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
    let url = String(info.node.key).substring(String(info.node.key).indexOf("_") + 1)
    window.location.href = url
  };

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-site-map']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
          {
            treeData 
            ?
            <Tree
              showLine
              switcherIcon={<DownOutlined />}
              defaultExpandAll={true}
              onSelect={onSelect}
              treeData={treeData}
            />
            :
            <>
              <Skeleton style={{ marginBottom: '60px' }}></Skeleton>
              <Skeleton style={{ marginBottom: '60px' }}></Skeleton>
              <Skeleton style={{ marginBottom: '60px' }}></Skeleton>
              <Skeleton></Skeleton>
            </>
          }
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}